import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import TextStyle from "@tiptap/extension-text-style";
import Color from "@tiptap/extension-color";
import TextAlign from "@tiptap/extension-text-align";
import Heading from "@tiptap/extension-heading";
import Paragraph from "@tiptap/extension-paragraph";
import ToolbarTextEditor from "./ToolbarTextEditor";
import "./textEditor.css";
import Stack from "@mui/material/Stack";
export default function TextEditor({ content, onChange }) {
	const editor = useEditor({
		extensions: [
			StarterKit.configure({
				heading: { levels: [1, 2] },
			}),
			Underline,
			TextStyle,
			Color,
			TextAlign.configure({
				types: ["heading", "paragraph"],
			}),
			Heading.configure({ levels: [1, 2] }),
			Paragraph,
		],
		content: content || "",
		onUpdate: ({ editor }) => {
			onChange?.(editor.getHTML());
		},
	});

	return (
		<Stack spacing={2}>
			{editor && <ToolbarTextEditor editor={editor} />}
			<EditorContent editor={editor} />
		</Stack>
	);
}
